import React from "react";
import { Typography, Stack, Container, Box, Button, Link } from "@mui/material";
import ModalWithLauncher from "../modals/ModalWithLauncher";
import LandingIllustration from "./LandingIllustration";
import Survey from "./Survey";
import { formId } from "shared/chrome/loginForm";
import googleAnalytics from "shared/analytics";

const LandingIntroTools = () => {
  const handleSignIn = (event) => {
    event.preventDefault();
    const form = document.getElementById(formId);
    form && form.submit();
    googleAnalytics.trackLoginClick("Already have account");
  };
  const ModalLauncher = () => (
    <Button
      onClick={() => googleAnalytics.trackTrialRequest("Location: top of landing page")}
      sx={(theme) => ({
        padding: theme.spacing(3),
        minWidth: "350px",
        background: "#FFFFFFA6",
        width: "100%",
        border: "white 1px solid",
        alignItems: "center",
        textAlign: "center",
        fontSize: 18,
        color: "black",
        justifyContent: "flex-start",
        fontWeight: 600,
        "&:hover,&:focus": {
          background: "white",
        },
        [theme.breakpoints.up("sm")]: {
          width: "auto",
          textAlign: "left",
          alignItems: "flex-start",
        },
      })}
    >
      Request Free Trial
    </Button>
  );
  return (
    <Box
      id="intro"
      component="section"
      sx={(theme) => ({
        paddingTop: "50px",
        paddingBottom: "50px",
        position: "relative",
        background: theme.palette.secondary.main,
        [theme.breakpoints.up("sm")]: {
          paddingTop: "150px",
        },
        width: "100vw",
        "&::after": {
          content: '""',
          background: theme.palette.secondary.main,
          minHeight: "300px",
          display: "block",
          borderBottomLeftRadius: "50% 85%",
          borderBottomRightRadius: "50% 85%",
          position: "absolute",
          left: "-25vw",
          right: "-25vw",
          width: "150vw",
          zIndex: 0,
        },
      })}
    >
      <Container>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="subtitle1"
                sx={(theme) => ({
                  color: "white",
                  font: "normal normal 300 60px/70px Lato",
                  marginBottom: theme.spacing(2),
                  "& strong": {
                    textTransform: "uppercase",
                  },
                  [theme.breakpoints.up("sm")]: {
                    marginBottom: theme.spacing(3),
                    font: "normal normal 300 78px/86px Lato",
                  },
                })}
              >
                From <strong>Insight</strong>
                <br />
                to <strong>Action</strong>
              </Typography>
              <Typography
                variant="body1"
                sx={(theme) => ({
                  fontSize: 22,
                  lineHeight: "32px",
                  fontWeight: 300,
                  color: "white",
                  marginBottom: theme.spacing(3),
                  [theme.breakpoints.up("sm")]: {
                    paddingRight: theme.spacing(3),
                  },
                })}
              >
                ICER Analytics™ revolutionizes your ability to <strong>develop formularies</strong>,{" "}
                <strong>negotiate drug prices</strong>, and explore new ways to{" "}
                <strong>apply evidence</strong> in a drive toward a health system that can achieve
                fair prices and fair access for all.
              </Typography>
              <Box sx={(theme) => ({ marginBottom: theme.spacing(1) })}>
                <ModalWithLauncher
                  i18nKey="surveyTrial"
                  Content={Survey}
                  Launcher={ModalLauncher}
                  mx={false}
                />
              </Box>
              <Typography
                sx={(theme) => ({
                  color: "white",
                  textAlign: "center",
                  "& a, & button": {
                    color: "white",
                    textDecoration: "underline",
                    "&:hover,&:focus": {
                      color: "rgba(255,255,255,.85)",
                    },
                  },
                  [theme.breakpoints.up("sm")]: {
                    textAlign: "left",
                    paddingLeft: theme.spacing(3),
                  },
                })}
              >
                Already have an account?{" "}
                <Link component="button" type="button" onClick={handleSignIn}>
                  <strong>Login</strong>
                </Link>
              </Typography>
            </Box>
          </Box>
          <Box sx={{ flex: 1, display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "1 1 100%",
                "& svg": {
                  flex: "1 1 100%",
                  width: "100%",
                },
              }}
            >
              <LandingIllustration />
            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default LandingIntroTools;
